import React from "react";
import { Container } from "./style";
const Com1 = () => {
  return (
    <Container>
      <div>{"Creator 등록"}</div>
      <div>{"하단 안내에 따라 S-Store에 등록하세요."}</div>
    </Container>
  );
};

export default Com1;
